export default __webpack_public_path__ + "static/media/10630-bojangle.f2c15fc5.pdf";